"use client"

interface PricingTrialHeaderProps {
    title: string
    subtitle: string
}

export function PricingTrialHeader({ title, subtitle }: PricingTrialHeaderProps) {
    return (
        <div>
            <p className="text-black font-bold text-xl sm:text-3xl tracking-normal">{title}</p>
            <p className="mt-1 text-black font-medium text-base tracking-normal">{subtitle}</p>
        </div>
    )
}
